
define('template!mailsListView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="labels-filter-region"></div>\n<div class="search-region"></div>\n<div class="mails-region"></div>';

}
return __p
};});

